import React, { useState, useContext } from "react";
import Modal from 'react-bootstrap/Modal';
import { getConfigValue } from '../../util/getConfigValue';
import { AppContext } from '../../util/AppContext';
import { useErrorBoundary } from "react-error-boundary";
import PropType from 'prop-types';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import dayjs from "dayjs";
import { getExportdDataCSV } from '../../API/UtilizationReportingDashboard';


ExportReportDataModal.propTypes = {
    show: PropType.bool,
    setShow: PropType.func,

}

function ExportReportDataModal({ show, setShow }) {
    const { showBoundary } = useErrorBoundary();
    const today = dayjs();
    const [appState] = useContext(AppContext);
    const [minStartDate] = useState(today.subtract(getConfigValue(appState.config?.UtilizationDashboard?.ExportData?.MaxMonths, appState)?.Value || 6, 'month').toDate());
    const [minEndDate, setMinEndDate] = useState(today.subtract(getConfigValue(appState.config?.UtilizationDashboard?.ExportData?.MaxMonths, appState)?.Value || 6, 'month').toDate());
    const [maxEndDate] = useState(today.toDate());
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(today.toDate());
    const [isValid, setIsValid] = useState(false);
    const [isLoading, setIsLoading] = useState(false);


    function onStartDate(date) {
        setMinEndDate(date);
        setStartDate(date);
        setIsValid(endDate !== null);
    }

    function onEndDate(date) {
        setEndDate(date);
        setIsValid(startDate !== null);
    }

    const handleExport = async (event) => {
        setIsLoading(true);
        await getExportdDataCSV({
            "startDate": startDate.toISOString().slice(0, 10),
            "endDate": endDate.toISOString().slice(0, 10)
        })
            .then((responseJson) => {
                setShow(false);
            })
            .catch((err) => {
                showBoundary(err);
            })
            .finally(() => {
                clear();
                setIsLoading(false);
            });

    }

    function handleCancel(event) {
        clear();
    }

    function clear() {
        setEndDate(today.toDate());
        setStartDate(null);
        setIsValid(false);
        setShow(false);
    }



    return (show &&
        <Modal show={show} className="modal-xl" onHide={() => clear()} scrollable={false}>
            <Modal.Header className="primary" closeButton>
                <Modal.Title className="modal-title type-20 fs-5">{getConfigValue(appState.config?.UtilizationDashboard?.ExportData?.Modal?.Title, appState)?.Value || "Export Utilization Data"}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="modal-body">
                <div className='container-xl'>
                    <label htmlFor="export-date_begin" className="form-label">{getConfigValue(appState?.config?.UtilizationDashboard?.ExportData?.StartDate?.Label, appState)?.Value || "Start Date:"} *</label>
                    <DatePicker
                        wrapperClassName="custom-datepicker-wrapper"
                        className="form-control qs-start-date w-100"
                        name="export-date_begin"
                        selected={startDate}
                        onChange={onStartDate}
                        minDate={minStartDate}
                        maxDate={endDate}
                    />

                    <div className="my-3"></div>
                    <label htmlFor="export-date_end" className="form-label">{getConfigValue(appState?.config?.UtilizationDashboard?.ExportData?.EndDate?.Label, appState)?.Value || "End Date: "} *</label>
                    <DatePicker
                        wrapperClassName="custom-datepicker-wrapper"
                        className="form-control qs-start-date w-100"
                        name="export-date_end"
                        selected={endDate}
                        onChange={onEndDate}
                        minDate={minEndDate}
                        maxDate={maxEndDate} />
                </div>
                <div className="row justify-content-center justify-content-md-end">
                    <div className="col-12 col-sm-8 col-md-8 col-lg-7">
                        <div className="d-flex flex-column flex-md-row-reverse">

                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <div className="container-fluid mx-0">
                    <div className="row justify-content-md-end px-0">
                        <div className="col-12 col-md-9 col-lg-7 px-0">
                            <div className="d-flex w-100 flex-column flex-md-row-reverse">
                                <button onClick={handleExport} disabled={!isValid || isLoading} className="btn btn-primary btn-lg mb-3 mb-md-0 ms-md-3 flex-fill w-100">{isLoading ? getConfigValue(appState.config.Common?.Loading, appState)?.Value : getConfigValue(appState.config?.UtilizationDashboard?.ExportData?.Button?.Label, appState)?.Value || "Export"}</button>
                                <button onClick={handleCancel} className="btn btn-secondary btn-lg flex-fill w-100" data-bs-dismiss="modal">Cancel</button>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal.Footer>
        </Modal>
    );
}

export default ExportReportDataModal;